import React, { memo, useContext, lazy, Suspense } from "react";
import NoSSR from "react-no-ssr";

import { __RouterContext as ReactRouterContext, Route } from "react-router";

import { AfterpartyProps, After } from "@jaredpalmer/after";

import useModalRoutes from "@/pages/App/useModalRoutes";
import { matchRoutes } from "react-router-config";
import renderRoutes from "@/utils/renderRoutes";

import Redirect from "@/pages/App/Redirect";

import { DEFAULT_ROUTE } from "@/routes";

const CookieConsent = lazy(() =>
  import(/* webpackPrefetch: true */ "@/pages/App/CookieConsent")
);

const Afterparty = (After as any).WrappedComponent;

type Location = import("history").Location;

export const defaultLocation: Location = {
  pathname: "/",
  search: "",
  state: null,
  hash: "",
};

const App: React.FC<Pick<AfterpartyProps, "data" | "routes">> = memo(
  ({ data, routes }) => {
    const ctx = useContext(ReactRouterContext);
    const { location, history, match } = ctx;

    const background = (location.state as any)?.background;
    const modalRoutes = useModalRoutes(background);
    const isModalRoute = matchRoutes(modalRoutes, history.location.pathname);

    return (
      <>
        <ReactRouterContext.Provider
          value={{
            ...ctx,
            location:
              background ??
              (isModalRoute.length > 0 ? defaultLocation : location),
          }}
        >
          <Afterparty
            data={data}
            routes={routes}
            {...{ location, history, match }}
          />
          <Route path="/" exact>
            <Redirect to={DEFAULT_ROUTE} />
          </Route>
        </ReactRouterContext.Provider>
        {renderRoutes(modalRoutes)}
        <NoSSR>
          <Suspense fallback={null}>
            <CookieConsent />
          </Suspense>
        </NoSSR>
      </>
    );
  }
);

export default App;
